const config = {
  COMPANY_NAME: "PM Clinic",
  API_BASE_URL: "https://stellabackend.patriciamota.pt",
  TOKEN_ID: "60df5ce957704730ed0bb88d",
  DEBUG_MODE: true,
};

export default config;
